import { render, staticRenderFns } from "./PlatformList.vue?vue&type=template&id=6c72c2f4&scoped=true"
import script from "./PlatformList.vue?vue&type=script&lang=js"
export * from "./PlatformList.vue?vue&type=script&lang=js"
import style0 from "./PlatformList.vue?vue&type=style&index=0&id=6c72c2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c72c2f4",
  null
  
)

export default component.exports